function storeInSessionStorage(key, value) {
  window.sessionStorage.setItem(key, JSON.stringify(value));
}

function URLRegularExpressionMatcher(string) {
  return !(string.match(/^\{/g) || string.match(/^\[/g) || string === 'false' || string === 'null' || string.match(/\d+/g) || string.match(/^"[^"]*"$/g));
}

function storeAsUrlSearchParams(key, value) {
  const urlSearchParams = new URLSearchParams(window.location.search);
  urlSearchParams.set(key, JSON.stringify(value));
  window.history.pushState(Object.fromEntries(urlSearchParams), null, `?${urlSearchParams.toString()}`);
}

function loadFromUrlSearchParams(key) {
  const hash = new URLSearchParams(window.location.search);
  let value = hash.get(key);
  if (value) {
    if (URLRegularExpressionMatcher(value)) {
      value = `"${value}"`;
    }
  }
  return value;
}

function loadFromSessionStorage(key) {
  return window.sessionStorage.getItem(key);
}

function store(key, value) {
  storeAsUrlSearchParams(key, value);
  storeInSessionStorage(key, value);
}

function storeHash(key, value) {
  storeInSessionStorage(key, value);
  window.location.hash = value;
}

function load(key) {
  let value = loadFromUrlSearchParams(key);
  if (!value) {
    value = loadFromSessionStorage(key);
  }

  if (value) {
    return JSON.parse(value);
  }
  return null;
}

function loadHash(key) {
  let value = decodeURI(window.location.hash.substring(1));

  if (!value) {
    value = JSON.parse(loadFromSessionStorage(key));
  }
  return value;
}

export {
  store, storeHash, load, loadHash,
};
